<!--<vl-form-validation-observer v-slot="{ handleSubmit, invalid, pristine }">-->
    <form class="vl-form" @submit="onSubmit">
        <vl-modal id="move-map-request-modal" mod-medium :closable="true">
            <vl-title tag-name="h3">Planaanvragen verplaatsen</vl-title>
            <vl-typography>Let op! Niet-gefactureerde planaanvragen kunnen niet verplaatst worden.</vl-typography>
            <vl-u-spacer mod-medium />
            <vl-form-grid mod-stacked>
                <vl-column>
                    <kl-field-validation-wrapper-yup :field="fields.selectedDestinationOrganisation" #default="{hasErrors}" mod-required>
                        <kl-search-organisation v-model="selectedDestinationOrganisation" :mod-error="hasErrors" :show-id="true" />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column v-if="selectedDestinationOrganisation">
                    <div v-kl-u-background-alt v-kl-u-box-padding>{{ selectedDestinationOrganisation.namePath }}</div>
                </vl-column>
                <vl-column>
                    <kl-field-validation-wrapper-yup :field="fields.reason" #default="{hasErrors}" mod-required>
                        <vl-textarea rows="6" name="reason" id="reason" v-model="reason" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
            </vl-form-grid>

            <template v-slot:modal-footer>
                <vl-action-group>
                    <vl-button type="submit" mod-large :mod-loading="movingMapRequests"
                            :mod-disabled="movingMapRequests">Verplaats planaanvragen</vl-button>
                    <vl-button type="button" mod-link @click.prevent="onCloseMoveMapRequestModal" icon="cross" mod-icon-before>Annuleer</vl-button>
                </vl-action-group>
            </template>
        </vl-modal>
    </form>
<!--</vl-form-validation-observer>-->
